import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { TABLE_HEADER_BACKGROUND_COLOR } from '../../../constants/colors';
import { ProductBadgeEnum } from '../../../enums/productBadge';
import { useTranslation } from 'react-i18next';


interface Props {
  value: ProductBadgeEnum
  onChange: (value: ProductBadgeEnum) => void
}

export default function ProductTabPanel({ value, onChange }: Props) {
  const { t } = useTranslation("global");

  return (
    <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR , borderRadius:'10px 10px 0 0'}}>
      <Box sx={{ borderColor: 'divider' }}>
        <Tabs value={value} onChange={(e: any, newValue: ProductBadgeEnum ) => {
          onChange(newValue)
        }} aria-label="basic tabs example" variant="scrollable"
          scrollButtons="auto">
          <Tab label={`${t("product_merchant_page.All products")}`} value={ProductBadgeEnum.AllProduct} sx={{ textTransform: 'none' }} />
          <Tab label={`${t("product_merchant_page.New product")}`} value={ProductBadgeEnum.NewProduct} sx={{ textTransform: 'none' }} />
          <Tab label={`${t("product_merchant_page.Recommend")}`}  value={ProductBadgeEnum.RecommendProduct} sx={{ textTransform: 'none' }} />
          <Tab label={`${t("product_merchant_page.Promotion")}`}  value={ProductBadgeEnum.PromotionProduct} sx={{ textTransform: 'none' }} />
        </Tabs>
      </Box>
    </Box>
  );
}
